export default "__VITE_ASSET__n0b$3z7y__"